<div [id]="mapId" class="map p-relative">
  @if (loading) { <app-overlay @fadeInOut></app-overlay> }
</div>
